import React, { memo, useCallback } from 'react';
//Material-UI
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction,
    Checkbox,
} from '@material-ui/core';
//Context
import { useLlamadas } from './LlamadasContext';

const NotifSection = memo(function NotifSection({ title, label, accent, items, checked, onToggle }) {
    return (
        <div className="llamada-notif-card" style={{ '--notif-accent': accent }}>
            <div className="llamada-notif-card-header">
                {label && <span className="llamada-notif-card-badge">{label}</span>}
                <span className="llamada-notif-card-title">{title}</span>
            </div>
            <List dense disablePadding>
                {items.map((item) => {
                    const labelId = `checkbox-list-label-${item.codigo}`;
                    return (
                        <ListItem key={item.codigo} className="llamada-notif-card-item">
                            <ListItemText primary={item.ubicacion} />
                            <ListItemSecondaryAction>
                                <ListItemIcon>
                                    <Checkbox
                                        edge="end"
                                        color="primary"
                                        onChange={onToggle(item.codigo)}
                                        checked={checked.indexOf(item.codigo) !== -1}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                            </ListItemSecondaryAction>
                        </ListItem>
                    );
                })}
            </List>
        </div>
    );
});

export default function LevantarNotificar() {
    const {
        deptos,
        nivel1Checked, setNivel1Checked,
        nivel2Checked, setNivel2Checked,
        nivel3Checked, setNivel3Checked,
        rolesChecked, setRolesChecked,
    } = useLlamadas();

    const toggleRoles  = useCallback((v) => () => setRolesChecked(p  => p.includes(v)  ? p.filter(x => x !== v)  : [...p, v]),  [setRolesChecked]);
    const toggleNivel1 = useCallback((v) => () => setNivel1Checked(p => p.includes(v)  ? p.filter(x => x !== v)  : [...p, v]), [setNivel1Checked]);
    const toggleNivel2 = useCallback((v) => () => setNivel2Checked(p => p.includes(v)  ? p.filter(x => x !== v)  : [...p, v]), [setNivel2Checked]);
    const toggleNivel3 = useCallback((v) => () => setNivel3Checked(p => p.includes(v)  ? p.filter(x => x !== v)  : [...p, v]), [setNivel3Checked]);

    const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || '#903bff';

    return (
        <div className="llamada-notif-layout">
            <NotifSection
                title="¿Quién puede levantar?"
                accent={accentColor}
                items={deptos}
                checked={rolesChecked}
                onToggle={toggleRoles}
            />
            <div className="llamada-notif-niveles">
                <NotifSection
                    title="Notificar"
                    label="Nivel 1"
                    accent="#2ccb9e"
                    items={deptos}
                    checked={nivel1Checked}
                    onToggle={toggleNivel1}
                />
                <NotifSection
                    title="Notificar"
                    label="Nivel 2"
                    accent="#ffc800"
                    items={deptos}
                    checked={nivel2Checked}
                    onToggle={toggleNivel2}
                />
                <NotifSection
                    title="Notificar"
                    label="Nivel 3"
                    accent="#fe424d"
                    items={deptos}
                    checked={nivel3Checked}
                    onToggle={toggleNivel3}
                />
            </div>
        </div>
    );
}
